import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { iniciarVerificacionIdentidad } from "../../funcionesDatos/verificacionIdentidad";

// Card de "Verifica tu identidad", mismo look de la app móvil.
// Se oculta sola cuando el usuario ya quedó verificado.
function BotonVerificar({ usuario, setUsuario, idServicio, className = "" }) {
  const [cargando, setCargando] = useState(false);
  const idUsuarioRef = useRef(usuario?.idUsuario);
  idUsuarioRef.current = usuario?.idUsuario;

  const estado = usuario?.verificacionIdentidad?.estado;
  const esPendiente = estado === "pendiente";

  // Mientras esté "pendiente", sondea cada pocos segundos si Didit ya respondió
  // (la aprobación llega por webhook, no al instante), y se actualiza solo.
  useEffect(() => {
    if (!esPendiente || typeof setUsuario !== "function") return;

    const intervalo = setInterval(async () => {
      try {
        const res = await axios.get("/verificar-token", { withCredentials: true });
        const usuarioActualizado = res?.data?.usuario;

        if (
          usuarioActualizado &&
          usuarioActualizado.idUsuario === idUsuarioRef.current &&
          usuarioActualizado?.verificacionIdentidad?.estado !== "pendiente"
        ) {
          setUsuario(usuarioActualizado);
        }
      } catch (err) { /* sondeo silencioso, no molestamos al usuario si falla */ }
    }, 6000);

    return () => clearInterval(intervalo);
  }, [esPendiente, setUsuario]);

  if (estado === "aprobado") return null;

  const esRechazado = estado === "rechazado";

  function handleClick() {
    if (esPendiente) return;
    iniciarVerificacionIdentidad(usuario, setCargando, idServicio);
  }

  return (
    <div
      className={`rounded-4 p-4 ${className}`}
      style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--naranja-claro-medio)" }}
    >
      <div className="d-flex align-items-start gap-3 mb-3">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: 48, height: 48, background: "var(--naranja-claro-medio)", color: "var(--naranja-cta)", fontSize: 20 }}
        >
          {esPendiente
            ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            : <i className="bi bi-person-badge"></i>}
        </div>
        <div>
          <h6 className="fw-bold mb-1">
            {esPendiente ? "Tu verificación está en revisión" : esRechazado ? "Reintenta tu verificación" : "Verifica tu identidad"}
          </h6>
          <p className="text-secondary mb-0" style={{ fontSize: 14 }}>
            {esPendiente
              ? "Te avisaremos apenas esté lista. Esta tarjeta se actualiza sola, no necesitas recargar la página."
              : esRechazado
              ? `Tu verificación anterior fue rechazada${usuario?.verificacionIdentidad?.razon && usuario.verificacionIdentidad.razon !== "NA" ? `: ${usuario.verificacionIdentidad.razon}` : "."} Vuelve a intentarlo con fotos nítidas.`
              : "Completa el escaneo de documento y reconocimiento facial para poder publicar servicios y generar más confianza."}
          </p>
        </div>
      </div>

      <button
        type="button"
        className="btn w-100 fw-semibold text-white d-flex align-items-center justify-content-center gap-2"
        style={{ background: "var(--naranja-cta)", borderColor: "var(--naranja-cta)", borderRadius: 999, padding: "12px 0" }}
        onClick={handleClick}
        disabled={esPendiente || cargando}
      >
        {esPendiente
          ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          : <i className="bi bi-shield-check"></i>}
        {cargando ? "Redirigiendo..." : esPendiente ? "Verificación en revisión" : esRechazado ? "Reintentar verificación" : "Verificar identidad"}
      </button>
    </div>
  );
}

export default BotonVerificar;
